import { render, staticRenderFns } from "./CountryFlag.vue?vue&type=template&id=14514bfa"
import script from "./CountryFlag.vue?vue&type=script&lang=js"
export * from "./CountryFlag.vue?vue&type=script&lang=js"
import style0 from "./CountryFlag.vue?vue&type=style&index=0&id=14514bfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports